import React from 'react';
import { FormattedMessage } from 'react-intl';

const AdvertiserRegistrationSuccessModal = ({ closeModal, error }) => (
  <div className="advertiser-reg-success">
    <div className="advertiser-reg-inner">
      <button type="button" className="popup-close" onClick={closeModal}>
        <i className="icon-cross-rounded" />
      </button>

      <div className="advertiser-reg-icon">
        <i className="icon-denied" />
      </div>

      <div className="advertiser-reg-text">
        <h2>
          <FormattedMessage
            id="advertiser.register.error_modal.title"
            defaultMessage="Error submitting form"
          />
        </h2>
        {error && <p>{error}</p>}
      </div>
    </div>
  </div>
);

export default AdvertiserRegistrationSuccessModal;
